// extracted by mini-css-extract-plugin
export default {"text":"CrossPromoVkMusicSeveralSubscriptions__text--2w2Pw","closeIconLight":"CrossPromoVkMusicSeveralSubscriptions__closeIconLight--2a2HL"};